export default {
      id: "oc-res-llm-image-usage",
      viewBox: "0 0 1068 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-llm-image",
      toString: function () {
        return this.url;
      }
    }